import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=2898fd2b&"
import script from "./news-detail.vue?vue&type=script&lang=js&"
export * from "./news-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./news-detail.vue?vue&type=custom&index=0&blockType=a&class=db%20mw6%20mt4%20btn-generic%20has-red-bg&href=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2F%3Fhl%3Den_US%26gl%3DUS&title=App%20Link&v-if=mobileOS%20%3D%3D%3D%20'Android'"
if (typeof block0 === 'function') block0(component)
import block1 from "./news-detail.vue?vue&type=custom&index=1&blockType=a&class=db%20mw6%20mt4%20btn-generic%20has-red-bg&href=https%3A%2F%2Fwww.apple.com%2Fapp-store%2F&title=App%20Link&v-else-if=mobileOS%20%3D%3D%3D%20'iOS'"
if (typeof block1 === 'function') block1(component)
import block2 from "./news-detail.vue?vue&type=custom&index=2&blockType=a&class=db%20mw6%20mt4%20btn-generic%20has-red-bg&href=https%3A%2F%2Fwww.google.com%2F&title=App%20Link&v-else-if=mobileOS%20%3D%3D%3D%20'other'"
if (typeof block2 === 'function') block2(component)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jacktransue/Documents/sfoutsidelands.com-2020/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2898fd2b')) {
      api.createRecord('2898fd2b', component.options)
    } else {
      api.reload('2898fd2b', component.options)
    }
    module.hot.accept("./news-detail.vue?vue&type=template&id=2898fd2b&", function () {
      api.rerender('2898fd2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/news-detail.vue"
export default component.exports